import { useNavigate } from '@remix-run/react';

interface CheckboxFilterProps {
	label: string;
	url: string;
	customCheckbox?: (active: boolean) => JSX.Element;
	active?: boolean;
}

export function CheckboxFilter({ label, url, active }: CheckboxFilterProps) {
	const navigate = useNavigate();
	const key = `${label}-${url}`;

	const changeHandler = () => {
		navigate(url);
	};

	return (
		<div className="flex items-center">
			<input
				type="radio"
				id={key}
				className="opacity-0 absolute h-4 w-4 cursor-pointer" // Invisible but still functional and accessible
				defaultChecked={active}
				onClick={changeHandler}
			/>
			<label
				htmlFor={key}
				className={`mr-2 h-4 w-4 rounded-full border border-blue cursor-pointer ${active ? 'bg-blue' : 'bg-white-pearl'}`}
			/>
			<label htmlFor={key} className="font-sans text-sm lg:text-base capitalize cursor-pointer">
				{label}
			</label>
		</div>
	);
}
